import React from "react";

import "core/components/common/loading.less";

export const LoadingIcon = () => <i className="fa fa-3x fa-refresh fa-spin" />;

export const LoadingElement = () => (
  <div className="component--loading">
    <div>
      <LoadingIcon />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/core/components/common/loading.tsx